import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  ref: "containerRef",
  class: "ai-container"
}
const _hoisted_2 = { class: "ai-answers" }
const _hoisted_3 = {
  key: 0,
  class: "ai-answers-area"
}
const _hoisted_4 = { class: "ai-answers-area" }
const _hoisted_5 = {
  key: 0,
  class: "answer-item-wrapper"
}
const _hoisted_6 = { class: "image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "answer-item-wrapper"
}
const _hoisted_9 = { class: "answer-item" }
const _hoisted_10 = {
  key: 2,
  class: "asked-item-wrapper"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "ai-ask" }
const _hoisted_13 = { class: "ai-ask-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_textarea = _resolveComponent("app-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.answers.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.t('greedyAI')), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (item) => {
        return (_openBlock(), _createElementBlock("section", {
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            (item.url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: item.url,
                      alt: "image"
                    }, null, 8, _hoisted_7)
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.ask)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.ask), 1)
                ]))
              : _createCommentVNode("", true),
            (item.answerHtml)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", {
                    innerHTML: item.answerHtml
                  }, null, 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_app_textarea, {
          loader: _ctx.loader,
          onApply: _ctx.apply
        }, null, 8, ["loader", "onApply"])
      ])
    ])
  ], 512))
}